import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { addDays, format } from "date-fns";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { PromemoriaButton } from "@/components/PromemoriaButton";
import { messaggioConferma } from "@/lib/whatsapp";

const ymd = (d) => format(d, "yyyy-MM-dd");

const Riga = ({ a, negozio, domani, onReload }) => (
  <li className="flex items-center gap-3 px-5 py-3 text-sm" data-testid={`dash-app-${a.id}`}>
    <span className="w-12 shrink-0 font-mono font-bold text-slate-900">{a.ora}</span>
    <div className="min-w-0 flex-1">
      <p className="truncate font-semibold text-slate-900">{a.cliente_nome} <span className="ml-1 text-[11px] font-bold uppercase tracking-wider text-orange-700">{a.tipo}</span></p>
      <p className="truncate text-xs text-slate-500">{a.bici_desc || "—"}{a.stato !== "programmato" ? ` · ${a.stato}` : ""}</p>
    </div>
    {domani ? <PromemoriaButton a={a} negozio={negozio} onDone={onReload} />
      : <WhatsAppButton compact telefono={a.cliente_telefono} text={messaggioConferma(a, negozio)} testId={`dash-app-whatsapp-${a.id}`} />}
  </li>
);

const Lista = ({ titolo, items, testId, ...rest }) => (
  <div data-testid={testId}>
    <p className="bg-slate-50 px-5 py-2 text-[11px] font-bold uppercase tracking-wider text-slate-500">{titolo} · {items.length}</p>
    <ul className="divide-y divide-slate-100">
      {items.map((a) => <Riga key={a.id} a={a} {...rest} />)}
      {!items.length && <li className="px-5 py-6 text-center text-sm text-slate-500">Nessun appuntamento.</li>}
    </ul>
  </div>
);

export const DashboardAppuntamenti = ({ negozio }) => {
  const [items, setItems] = useState([]);
  const oggi = ymd(new Date());
  const domani = ymd(addDays(new Date(), 1));
  const load = useCallback(() => api.get("/appuntamenti", { params: { da: oggi, a: domani } }).then((r) => setItems(r.data)).catch(() => {}), [oggi, domani]);
  useEffect(() => { load(); }, [load]);
  const attivi = items.filter((a) => a.stato !== "annullato");
  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-testid="dashboard-appuntamenti">
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
        <h2 className="font-heading text-base font-bold text-slate-900">Appuntamenti</h2>
        <Link to="/agenda" className="flex items-center gap-1 text-xs font-semibold text-orange-600 hover:underline" data-testid="dashboard-goto-agenda">Agenda <ArrowRight className="h-3 w-3" /></Link>
      </div>
      <Lista titolo="Oggi" testId="dashboard-app-oggi" items={attivi.filter((a) => a.data === oggi)} negozio={negozio} onReload={load} />
      <Lista titolo="Domani · invia il promemoria" testId="dashboard-app-domani" items={attivi.filter((a) => a.data === domani && a.stato === "programmato")} negozio={negozio} domani onReload={load} />
    </div>
  );
};
